import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function PdfFormTemplatesAPI(): BringozApi {
  return {
    base: `/pdfFormTemplates`,
    infiniteScroll: {
      address: `/pdfFormTemplates`,
      cmd: 'GET'
    },
    actions: {
      getList: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      getOne: {
        address: '{id}',
        cmd: 'GET',
        updateable: false
      },
      createOne: {
        address: '',
        cmd: 'PUT',
        updateable: false
      },
      uploadOne: {
        address: 'uploadForm',
        cmd: 'PUT',
        updateable: false
      },
      updateOne: {
        address: '{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteOne: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      }
    }
  }
}
angular
  .module('bringoz.admin.document-management')
  .factory('PdfFormTemplatesAPI', PdfFormTemplatesAPI);
